import styled from "styled-components";
import BasedModal from "components/BaseModalComponents/BasedModal";
import { PlusIcon } from "assets/images";
import { CloseCross } from "assets/images";
import { LightTrashIcon } from "../../../assets/images";

export const Search = styled.input`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    color: black;
    padding: 8px 10px;
    border-radius: 5px;

    :focus {
        outline: none;
    }
`;

export const PinCheckbox = styled.input.attrs({ type: "checkbox" })<{
    disabled?: boolean;
}>`
    width: 16px;
    height: 16px;
    margin: 0 8px 0 0;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
    accent-color: #4a90d9;
    flex-shrink: 0;
`;
export const StarWrapper = styled.div<{ disabled: boolean }>`
    display: flex;
    align-items: center;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

    * {
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    }

    svg {
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    }
`;
export const TabItemRow = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    //padding-right: 12px;
    max-height: 500px;
`;

export const DropTabDiv = styled.div`
    border-bottom: solid 1px;
    border-color: ${(props) => props.theme.color.lightGreen};
    cursor: pointer;
    transition: 0.2s;

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    span:hover {
        transition: 0.2s;
        //filter: brightness(84%);
        //transform: translate(10px)
    }
`;

export const NameSpan = styled.span`
    padding: 10px 0;
    flex-grow: 1;
    height: 100%;
    max-width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
`;

export const CustomLightTrashIcon = styled(LightTrashIcon)`
    margin-right: 10px;
`;

export const CustomBasedModal = styled(BasedModal)`
    width: 250px;
    height: 350px;
`;

export const CustomPlusIcon = styled(PlusIcon)`
    cursor: pointer;

    :hover {
        filter: brightness(80%);
    }
`;

export const StyledCross = styled(CloseCross)`
    position: absolute;
    top: -32px;
    right: -55px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;

    :hover {
        transform: scale(1.05);
    }
`;
